import { render, staticRenderFns } from "./showRefundRules.vue?vue&type=template&id=fdc61588&scoped=true&"
import script from "./showRefundRules.vue?vue&type=script&lang=js&"
export * from "./showRefundRules.vue?vue&type=script&lang=js&"
import style0 from "./showRefundRules.vue?vue&type=style&index=0&id=fdc61588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc61588",
  null
  
)

export default component.exports